import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { buy_requestsApi } from "../../app/slices/buy_requestsSlice";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";

import { Box, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI

// import { Loader } from "lucide-react";
import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";
import Filter from "../../components/Filter";
// import { toast } from "react-toastify";

export default function BuyRequests() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  // useEffect(() => {
  //   dispatch(buy_requestsApi(queryParams));
  // }, [dispatch, queryParams]);

    const [filterData, setFilterData] = useState({
          startDate: "",
          endDate: "",
         
       
          name: "",
        
       
     
        merchantTransactionId:"",
        pgorderId:"",
          customerRefNo: "",
         
        });
      
          const url = `/api/admin/augmont-buy-req/list`
        
          const { handleFilterSubmit, handleClearFilters, loader, results, apiCall,message,error,toastTrigger } = useFilterHandler(url, filterData, setFilterData)
  
   useEffect(() => {
      apiCall(false)
    }, []);
  
     useEffect(() => {
    if (!message) return;
  
    console.log("Message updated:", message);
  
    if (error) {
      toast.error(message);
    } 
    // else {
    //   // toast.success(message);
    // }
  }, [toastTrigger]);

  const sliceResponse = useSelector(
    (state) => state.buy_requests.buy_requests.data
  );
  
  const stateLoading = useSelector(
    (state) => state.buy_requests.loading
  );
  
  // loading={stateLoading}

  const columnHelper = createMRTColumnHelper();

  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };
        
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("customerName", {
      header: "Name",
      size: 30,
     
    }),

     columnHelper.accessor("phone", {
      header: "Phone",
      size: 30,
     
    }),
    
   
    // columnHelper.accessor("partner_username", {
    //   header: "Partner Username",
    //   size: 30,
    //   Cell: (cell) => {
    //     cell.row.original?.partner_username;
    //   },
    // }),
    
    
    columnHelper.accessor("metalType", {
     header: "Metal Type",
     size: 30,
    
   }),

    columnHelper.accessor("buyType", {
     header: "Buy Type",
     size: 30,
    
   }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
     
    }),

    columnHelper.accessor("amount", {
      header: "Total Amount",
      size: 30,
     
    }),
    columnHelper.accessor("pricePerGram", {
      header: "Metal Rate",
      size: 30,
     
    }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId
          );
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),
     columnHelper.accessor("orderId", {
      header: "PG orderId",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.orderId || "N/A");
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.orderId || "N/A"}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.orderId || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("blockId", {
      header: "Block ID",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.blockId}</div>
      ),
    }),
    columnHelper.accessor("partner_id", {
      header: "partner_id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partner_id || "N/A");
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.partner_id || "N/A"}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.partner_id || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 30,
     
    }),
    // columnHelper.accessor("goldPrice", {
    //   header: "Gold Price",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>
    //       ₹{cell.row.original?.goldPrice}
    //     </div>
    //   ),
    // }),
    // columnHelper.accessor("silverPrice", {
    //   header: "Silver Price",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>
    //       ₹{cell.row.original?.goldPrice}
    //     </div>
    //   ),
    // }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
    }),
  ];

  return (
    <>
      {/* */}
      <Filter filterData={filterData} onFilterSubmit={handleFilterSubmit} Onclear={handleClearFilters} page={'augmont_buy_req'} setFilterData={setFilterData} />
      {/* {sliceResponse ? ( */}
        <>
          {/* <DateSearchComponent onSearch={handleSearch} /> */}
        <Box mt={2} >

         {loader?<Loader/>:<CustomTable columns={columns} data={results} loading={loader} permissionKey="BuyRequest"/>} 
          </Box>
        </>
      {/* ) : (
        <LinearProgress />
      )} */}
    </>
  );
}
